"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
var _shopList = require("@/api/shop/shopList.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BannerComponent',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this = this;
    return {
      imagePrefix: '',
      bannerList: [],
      selectedBanners: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '添加Banner',
      isEdit: false,
      currentId: null,
      pageList: [],
      // 页面列表数据
      groupOptions: [],
      // 分组选项列表
      groupLoading: false,
      // 分组加载状态
      regionList: [],
      // 城市区域列表
      // 发布位置筛选
      publishPositionFilter: '',
      // 当前选中的发布位置筛选条件
      publishPositionOptions: [
      // 发布位置筛选选项
      {
        label: '全部',
        value: ''
      }, {
        label: '首页-顶部',
        value: 'top'
      }, {
        label: '首页-底部',
        value: 'bottom'
      }, {
        label: '首页-中部',
        value: 'middle'
      }],
      // 预览弹窗相关
      previewVisible: false,
      previewImageUrl: '',
      formData: {
        publishPosition: 'top',
        // 默认选择顶部位置
        name: '',
        // 名称
        desc: '',
        // 说明
        jumpUrl: '',
        city: [],
        // 改为数组以支持多选，存储城市ID，-1表示全部
        groupType: 0,
        // 分组类型：0 不匹配分组，1 CDP分组，2 消费行为
        groupId: '',
        sort: 1,
        param: '',
        // 跳转参数
        imageUrl: '',
        platform: [],
        // 展示平台，支持多选
        enable: false,
        // 是否显示
        isMember: '1',
        // 1-全部, 2-会员, 3-游客
        isAddWechat: '1',
        // 1-全部, 2-是, 3-否
        isOrdered: '1',
        // 1-全部, 2-未下过单, 3-下过单
        isNewUserCouponExpired: '1',
        // 新人券是否过期：1-全部, 2-新人券过期, 3-新人券未过期
        memberLevel: [],
        // 会员等级：1-5，支持多选
        linkType: '1' // 链接类型：1-下拉选择内容, 2-外链地址输入
      },
      rules: {
        publishPosition: [{
          required: true,
          message: '请选择发布位置',
          trigger: 'change'
        }],
        linkType: [{
          required: true,
          message: '请选择链接类型',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        desc: [{
          max: 200,
          message: '说明长度不能超过200个字符',
          trigger: 'blur'
        }],
        jumpUrl: [{
          required: true,
          message: '请填写跳转页面',
          trigger: 'change'
        }],
        groupType: [{
          required: true,
          message: '请选择分组类型',
          trigger: 'change'
        }],
        groupId: [{
          validator: function validator(rule, value, callback) {
            if (_this.formData.groupType != 0 && (!value || value === '')) {
              callback(new Error('请选择分组'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        city: [{
          required: true,
          message: '请选择城市',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'change'
        }],
        imageUrl: [{
          required: true,
          message: '请上传素材',
          trigger: 'change'
        }],
        platform: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择至少一个展示平台',
          trigger: 'change'
        }],
        isMember: [{
          required: true,
          message: '请选择是否会员',
          trigger: 'change'
        }],
        isAddWechat: [{
          required: true,
          message: '请选择添加企微',
          trigger: 'change'
        }],
        isOrdered: [{
          required: true,
          message: '请选择是否下单',
          trigger: 'change'
        }],
        isNewUserCouponExpired: [{
          required: true,
          message: '请选择新人券是否过期',
          trigger: 'change'
        }],
        memberLevel: [{
          required: true,
          type: 'array',
          message: '请选择会员等级',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {},
  watch: {},
  created: function created() {
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取图片前缀
    this.getImagePrefix();
    // 获取页面列表
    this.getPageList();
    // 获取城市区域数据
    this.getRegionList();
  },
  methods: {
    handleLinkTypeChange: function handleLinkTypeChange() {
      this.formData.jumpUrl = '';
    },
    getPublishPositionLabel: function getPublishPositionLabel(publishPosition) {
      switch (publishPosition) {
        case 'top':
          return '首页-顶部';
        case 'bottom':
          return '首页-底部';
        case 'middle':
          return '首页-中部';
        default:
          return publishPosition;
      }
    },
    handlePublishPositionChange: function handlePublishPositionChange(data) {
      data.jumpUrl = "";
    },
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    // 类型文本映射
    getTypeText: function getTypeText(type) {
      switch (type) {
        case 0:
          return '默认';
        case 1:
          return '城市';
        case 2:
          return '分组';
        default:
          return '未知';
      }
    },
    // 类型标签样式映射
    getTypeTag: function getTypeTag(type) {
      switch (type) {
        case 0:
          return 'success';
        case 1:
          return 'primary';
        case 2:
          return 'warning';
        default:
          return 'info';
      }
    },
    // 类型切换处理
    onTypeChange: function onTypeChange() {
      // 如果不是分组类型，清空分组ID
      if (this.formData.type !== 2) {
        this.formData.groupId = '';
      }
    },
    // 分组类型切换处理
    handleGroupTypeChange: function handleGroupTypeChange() {
      // 清空分组ID
      this.formData.groupId = '';
      this.queryGroupList('');
    },
    // 城市选择变化处理
    handleCityChange: function handleCityChange(val) {
      if (!val || !Array.isArray(val)) {
        this.formData.city = [];
        return;
      }

      // 如果选择了"全部"(-1)，则只保留"全部"
      if (val.includes(-1)) {
        this.formData.city = [-1];
      }
      // 如果没有选择"全部"，但之前选择过，则移除"全部"
      else if (val.length > 0) {
        this.formData.city = val.filter(function (id) {
          return id !== -1;
        });
      }
    },
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    // 添加Banner
    handleAdd: function handleAdd() {
      this.dialogTitle = '添加Banner';
      this.isEdit = false;
      this.dialogVisible = true;
      this.resetForm();
    },
    // 编辑Banner
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var loadingInstance, response, detailData, extraData, cityData, platformData, memberLevelData, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              loadingInstance = null;
              _context2.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置项详情
              _context2.next = 2;
              return (0, _decorateConfigItem.getConfigItemDetail)(row.id);
            case 2:
              response = _context2.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 解析详情数据
                detailData = response.data;
                extraData = detailData.extra ? JSON.parse(detailData.extra) : {};
                this.dialogTitle = '编辑Banner';
                this.isEdit = true;
                this.currentId = detailData.id;
                this.dialogVisible = true;

                // 填充表单数据
                cityData = Array.isArray(extraData.city) ? extraData.city : extraData.city ? [extraData.city] : [];
                platformData = Array.isArray(extraData.platform) ? extraData.platform : extraData.platform ? [extraData.platform] : [];
                memberLevelData = Array.isArray(extraData.memberLevel) ? extraData.memberLevel : extraData.memberLevel ? [extraData.memberLevel] : [];
                this.formData = {
                  publishPosition: extraData.publishPosition || 'top',
                  // 添加发布位置字段
                  name: extraData.name || '',
                  // 名称
                  desc: extraData.desc || '',
                  // 说明
                  jumpUrl: extraData.jumpUrl || '',
                  city: cityData,
                  groupType: extraData.groupType !== undefined ? extraData.groupType : 0,
                  groupId: extraData.groupId || '',
                  sort: extraData.sort !== undefined ? extraData.sort : 1,
                  imageUrl: extraData.imageUrl || '',
                  platform: platformData,
                  enable: detailData.enable,
                  isMember: (extraData.isMember || '1').toString(),
                  // 是否会员
                  isAddWechat: (extraData.isAddWechat || '1').toString(),
                  // 添加企微
                  isOrdered: (extraData.isOrdered || '1').toString(),
                  // 是否下单
                  isNewUserCouponExpired: (extraData.isNewUserCouponExpired || '1').toString(),
                  // 新人券是否过期
                  memberLevel: memberLevelData,
                  // 会员等级
                  param: extraData.param || '',
                  // 跳转参数
                  linkType: (extraData.linkType || '1').toString() // 链接类型
                };

                // 如果有分组类型，加载对应的分组列表
                if (this.formData.groupType) {
                  this.queryGroupList('');
                }
              } else {
                this.$message.error(response.message || '加载详情失败!');
              }
              _context2.next = 4;
              break;
            case 3:
              _context2.prev = 3;
              _t2 = _context2["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('加载详情失败:', _t2);
              this.$message.error('加载详情失败: ' + (_t2.message || '未知错误'));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    // 移除Banner
    handleRemove: function handleRemove(row) {
      var _this2 = this;
      this.$confirm('确定要移除该Banner吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _decorateConfigItem.deleteConfigItem)(row.id);
            case 1:
              response = _context3.sent;
              if (!(response.code === 200)) {
                _context3.next = 3;
                break;
              }
              _context3.next = 2;
              return _this2.loadConfig();
            case 2:
              _this2.$message.success('移除成功');
              _context3.next = 4;
              break;
            case 3:
              _this2.$message.error(response.message || '删除失败!');
            case 4:
              _context3.next = 6;
              break;
            case 5:
              _context3.prev = 5;
              _t3 = _context3["catch"](0);
              console.error('删除失败:', _t3);
              _this2.$message.error('删除失败: ' + (_t3.message || '未知错误'));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 5]]);
      }))).catch(function () {
        _this2.$message.info('已取消移除');
      });
    },
    // 切换显示状态
    handleToggleVisible: function () {
      var _handleToggleVisible = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context4.sent;
              if (!(response.code === 200)) {
                _context4.next = 3;
                break;
              }
              _context4.next = 2;
              return this.loadConfig();
            case 2:
              this.$message.success("\u66F4\u65B0\u6210\u529F");
              _context4.next = 4;
              break;
            case 3:
              // 如果接口调用失败，恢复开关状态
              row.visible = !row.visible;
              this.$message.error(response.message || '操作失败!');
            case 4:
              _context4.next = 6;
              break;
            case 5:
              _context4.prev = 5;
              _t4 = _context4["catch"](0);
              // 如果接口调用失败，恢复开关状态
              row.visible = !row.visible;
              console.error('操作失败:', _t4);
              this.$message.error('操作失败: ' + (_t4.message || '未知错误'));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 5]]);
      }));
      function handleToggleVisible(_x2) {
        return _handleToggleVisible.apply(this, arguments);
      }
      return handleToggleVisible;
    }(),
    // 提交表单
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
                  var loadingInstance, data, response, _t5;
                  return regeneratorRuntime.wrap(function (_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (valid) {
                          _context5.next = 1;
                          break;
                        }
                        return _context5.abrupt("return");
                      case 1:
                        loadingInstance = null;
                        _context5.prev = 2;
                        data = {
                          id: _this3.isEdit ? _this3.currentId : null,
                          pageCode: _this3.pageKey,
                          optionCode: _this3.moduleKey,
                          title: 'Banner',
                          enable: _this3.formData.enable,
                          sort: _this3.formData.sort,
                          extra: JSON.stringify({
                            jumpUrl: _this3.formData.jumpUrl,
                            city: _this3.formData.city,
                            groupType: _this3.formData.groupType,
                            groupId: _this3.formData.groupId,
                            imageUrl: _this3.formData.imageUrl,
                            platform: _this3.formData.platform,
                            publishPosition: _this3.formData.publishPosition,
                            // 添加发布位置字段
                            name: _this3.formData.name,
                            // 名称
                            desc: _this3.formData.desc,
                            // 说明
                            isMember: _this3.formData.isMember,
                            // 是否会员
                            isAddWechat: _this3.formData.isAddWechat,
                            // 添加企微
                            isOrdered: _this3.formData.isOrdered,
                            // 是否下单
                            isNewUserCouponExpired: _this3.formData.isNewUserCouponExpired,
                            // 新人券是否过期
                            memberLevel: _this3.formData.memberLevel,
                            // 会员等级
                            linkType: _this3.formData.linkType,
                            // 链接类型
                            param: _this3.formData.param // 跳转参数
                          })
                        }; // 显示保存loading状态
                        loadingInstance = _this3.$loading({
                          lock: true,
                          text: '保存中...',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                        });

                        // 调用后端接口保存配置
                        _context5.next = 3;
                        return (0, _decorateConfigItem.saveConfigItem)(data);
                      case 3:
                        response = _context5.sent;
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        if (!(response.code === 200)) {
                          _context5.next = 5;
                          break;
                        }
                        // 保存成功后关闭对话框
                        _this3.dialogVisible = false;
                        // 刷新列表数据
                        _context5.next = 4;
                        return _this3.loadConfig();
                      case 4:
                        _this3.$message.success(_this3.isEdit ? '编辑成功' : '添加成功');
                        _context5.next = 6;
                        break;
                      case 5:
                        _this3.$message.error(response.message || '保存失败!');
                      case 6:
                        _context5.next = 8;
                        break;
                      case 7:
                        _context5.prev = 7;
                        _t5 = _context5["catch"](2);
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        console.error('保存失败:', _t5);
                        _this3.$message.error('保存失败: ' + (_t5.message || '未知错误'));
                      case 8:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5, null, [[2, 7]]);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    // 重置表单
    resetForm: function resetForm() {
      this.currentId = null;
      this.formData = {
        publishPosition: 'top',
        //是否会员顶部位置
        name: '',
        // 名称
        desc: '',
        // 说明
        jumpUrl: '',
        city: [],
        // 改为数组以支持多选，存储城市ID，-1表示全部
        groupType: 0,
        // 分组类型：0 默认，1 CDP分组，2 消费行为
        groupId: '',
        sort: 1,
        visible: false,
        imageUrl: '',
        platform: [],
        // 展示平台，支持多选
        isMember: '1',
        // 是否会员
        isAddWechat: '1',
        // 添加企微
        isOrdered: '1',
        // 是否下单
        isNewUserCouponExpired: '1',
        // 新人券是否过期
        memberLevel: [],
        // 会员等级：1-5，支持多选
        linkType: '1' // 链接类型：1-下拉选择内容, 2-外链地址输入
      };
      if (this.$refs.form) this.$refs.form.clearValidate();

      // 清空分组选项
      this.groupOptions = [];
    },
    // 点击图片预览区域
    handleImageClick: function handleImageClick() {
      this.$refs.fileInput.click();
    },
    // 文件选择变化
    handleFileChange: function handleFileChange(event) {
      var files = event.target.files;
      if (files.length === 0) return;
      var file = files[0];
      if (this.validateImage(file)) {
        this.uploadImage(file);
      }

      // 清空input值，允许重复选择同一文件
      event.target.value = '';
    },
    // 判断是否为视频文件
    isVideoFile: function isVideoFile(url) {
      if (!url) return false;
      var ext = url.split('.').pop().toLowerCase();
      return ['mp4', '3gp', 'm3u8'].includes(ext);
    },
    // 验证上传文件
    validateImage: function validateImage(file) {
      var isImage = file.type.startsWith('image/');
      var isVideo = file.type.startsWith('video/');
      var ext = file.name.split('.').pop().toLowerCase();
      var isM3u8 = ext === 'm3u8';
      if (!isImage && !isVideo && !isM3u8) {
        this.$message.error('只能上传图片或视频文件!');
        return false;
      }
      if (isImage && file.size / 1024 / 1024 > 5) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      if ((isVideo || isM3u8) && file.size / 1024 / 1024 > 50) {
        this.$message.error('视频大小不能超过 50MB!');
        return false;
      }
      return true;
    },
    // 上传图片
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(file) {
        var _loading, response, imageUrl, _t6;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              // 显示上传loading状态
              _loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口上传文件
              _context7.next = 1;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 1:
              response = _context7.sent;
              // 关闭loading
              _loading.close();
              if (response.code === 200) {
                imageUrl = response.data;
                this.formData.imageUrl = imageUrl;
                this.$message.success('上传成功!');
              } else {
                this.$message.error(response.message || '上传失败!');
              }
              _context7.next = 3;
              break;
            case 2:
              _context7.prev = 2;
              _t6 = _context7["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('上传失败:', _t6);
              this.$message.error('上传失败: ' + (_t6.message || '未知错误'));
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function uploadImage(_x4) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var loadingInstance, response, _t7;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              loadingInstance = null;
              _context8.prev = 1;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置
              _context8.next = 3;
              return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize, null, this.publishPositionFilter);
            case 3:
              response = _context8.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.records) {
                // 解析配置信息
                this.bannerList = response.records.map(function (item) {
                  var extra = item.extra ? JSON.parse(item.extra) : {};
                  // 处理城市数据，确保是数组格式
                  var cityData = [];
                  if (Array.isArray(extra.city)) {
                    cityData = extra.city;
                  } else if (extra.city !== undefined && extra.city !== null) {
                    cityData = [extra.city];
                  }
                  return _objectSpread(_objectSpread({}, item), {}, {
                    extra: extra,
                    // 兼容旧数据结构
                    jumpUrl: extra.jumpUrl || '',
                    city: cityData,
                    groupType: extra.groupType !== undefined ? extra.groupType : 0,
                    groupId: extra.groupId || '',
                    sort: item.sort !== undefined ? item.sort : 1,
                    visible: item.enable !== undefined ? item.enable : false
                  });
                });
                this.total = response.total;
                // this.currentPage = response.current
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              _context8.next = 5;
              break;
            case 4:
              _context8.prev = 4;
              _t7 = _context8["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('配置加载失败:', _t7);
              this.$message.error('配置加载失败: ' + (_t7.message || '未知错误'));
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[1, 4]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var response, _t8;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context9.sent;
              if (response.code === 200 && response.data) {
                this.pageList = response.data.filter(function (item) {
                  return item.appid === 'GAGAX' || item.appid === 'DELI';
                });
              } else {
                this.$message.error(response.message || '获取页面列表失败!');
              }
              _context9.next = 3;
              break;
            case 2:
              _context9.prev = 2;
              _t8 = _context9["catch"](0);
              console.error('获取页面列表失败:', _t8);
              this.$message.error('获取页面列表失败: ' + (_t8.message || '未知错误'));
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 查询分组列表
    queryGroupList: function () {
      var _queryGroupList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(query) {
        var response, _t9;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              if (this.formData.groupType) {
                _context0.next = 1;
                break;
              }
              this.groupOptions = [];
              return _context0.abrupt("return");
            case 1:
              this.groupLoading = true;
              _context0.prev = 2;
              _context0.next = 3;
              return (0, _popupConfig.queryCdpGroupList)({
                type: this.formData.groupType,
                name: query || ''
              });
            case 3:
              response = _context0.sent;
              if (response.code === 200 && response.data) {
                this.groupOptions = response.data.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name
                  };
                });
              }
              _context0.next = 5;
              break;
            case 4:
              _context0.prev = 4;
              _t9 = _context0["catch"](2);
              console.error('获取分组列表失败:', _t9);
              this.$message.error('获取分组列表失败: ' + (_t9.message || '网络错误'));
            case 5:
              _context0.prev = 5;
              this.groupLoading = false;
              return _context0.finish(5);
            case 6:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[2, 4, 5, 6]]);
      }));
      function queryGroupList(_x5) {
        return _queryGroupList.apply(this, arguments);
      }
      return queryGroupList;
    }(),
    // 获取城市区域数据
    getRegionList: function () {
      var _getRegionList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var response, _t0;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.prev = 0;
              _context1.next = 1;
              return (0, _shopList.getStoreRegionAllData)();
            case 1:
              response = _context1.sent;
              if (response.code === 200 && response.data) {
                this.regionList = response.data;
              } else {
                this.$message.error(response.message || '获取城市区域数据失败!');
              }
              _context1.next = 3;
              break;
            case 2:
              _context1.prev = 2;
              _t0 = _context1["catch"](0);
              console.error('获取城市区域数据失败:', _t0);
              this.$message.error('获取城市区域数据失败: ' + (_t0.message || '未知错误'));
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this, [[0, 2]]);
      }));
      function getRegionList() {
        return _getRegionList.apply(this, arguments);
      }
      return getRegionList;
    }(),
    // 根据页面URL获取页面名称
    getPageNameByUrl: function getPageNameByUrl(url) {
      if (!url) return '';
      var page = this.pageList.find(function (item) {
        return item.pageUrl === url;
      });
      return page ? page.pageName : url;
    },
    // 根据城市ID获取城市名称
    getCityNameById: function getCityNameById(cityId) {
      if (cityId === -1) return '全部';
      var city = this.regionList.find(function (item) {
        return item.id === cityId;
      });
      return city ? city.name : cityId;
    },
    // 处理表格选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedBanners = selection;
    },
    // 预览功能
    preview: function () {
      var _preview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var loadingInstance, ids, previewData, response, _t1;
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(this.selectedBanners.length === 0)) {
                _context10.next = 1;
                break;
              }
              this.$message.warning('请至少选择一条数据进行预览');
              return _context10.abrupt("return");
            case 1:
              loadingInstance = null;
              _context10.prev = 2;
              // 获取选中数据的ID
              ids = this.selectedBanners.map(function (item) {
                return item.id;
              }); // 构造预览参数
              previewData = {
                ids: ids,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                xcxType: this.xcxType,
                pageURl: "" // 设置默认页面URL，可根据实际需求调整
              }; // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '预览生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用预览接口
              _context10.next = 3;
              return (0, _decorateConfig.previewAdd)(previewData);
            case 3:
              response = _context10.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有二维码URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了二维码URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  } else {
                    this.$message.success('预览二维码生成成功');
                  }
                } else {
                  this.$message.success('预览二维码生成成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context10.next = 5;
              break;
            case 4:
              _context10.prev = 4;
              _t1 = _context10["catch"](2);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('预览失败:', _t1);
              this.$message.error('预览失败: ' + (_t1.message || '未知错误'));
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[2, 4]]);
      }));
      function preview() {
        return _preview.apply(this, arguments);
      }
      return preview;
    }(),
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 组件销毁前释放资源
    beforeDestroy: function beforeDestroy() {
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    }
  }
};